import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func
};

export default function RHFTextField({ name, onChange, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField {...field} fullWidth error={error} helperText={error?.message} 
          onChange={e=>{
            field.onChange(e);
            if ( onChange )
              onChange(e);
          }}
        {...other} />
      )}
    />
  );
}
